import React from 'react';
import styles from './styles.css';
import classnames from 'classnames';
import Tick from '../icons/tick';

export class SKU extends React.Component {

    constructor(props) {
        super(props);
    };

    render() {

        let sku = this.props.sku;

        return (
            <span className={classnames(styles.sku, sku.active ? styles.active : '')}
                style={{ backgroundImage: `url(${sku.paletteImage})`, backgroundSize: 'contain' }}
                onClick={() => { this.props.onClick(); }}
                >
                    {
                        sku.active &&
                        <Tick className={styles.tick}></Tick>
                    }
            </span>
        )
    };
};